import {
    LIST_LEVELS,
    LIST_LEVELS_SUCCESS,
    LIST_LEVELS_ERROR,
    ADD_LEVELS,
    SAVE_LEVELS,
    SAVE_LEVELS_SUCCESS,
    SAVE_LEVELS_ERROR,
    DELETE_LEVELS,
    DELETE_LEVELS_SUCCESS,
    DELETE_LEVELS_ERROR,
    EDIT_LEVELS,
    UPDATE_LEVELS,
    UPDATE_LEVELS_SUCCESS,
    UPDATE_LEVELS_ERROR
} from '../types';

import clienteAxios from '../config/axios';

import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';

const controller = 'nivel';

const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1OTcxNzk2NDQsInVzZXJfbmFtZSI6IjY3MjgiLCJhdXRob3JpdGllcyI6WyJFTElNSU5BUl9QQVJBTUVUUk9TIiwiTklWRUxFUyIsIlJFU0VSVkFSX0FVRElFTkNJQVMiLCJWRV9SRVBPUlRFUyIsIkNSRUFSX0lOSElCSUNJT05FUyIsIkVMSU1JTkFSX1RVUk5PUyIsIkxJU1RBUl9GVU5DSU9OQVJJT1MiLCJNT0RJRklDQVJfSlVFQ0VTIiwiQ1JFQVJfVVNVQVJJT1MiLCJNT0RJRklDQVJfVFVSTk9TIiwiRUxJTUlOQVJfSU5ISUJJQ0lPTkVTIiwiTU9ESUZJQ0FSX0ZVTkNJT05BUklPUyIsIkxJU1RBUl9PRklKVVMiLCJNT0RJRklDQVJfU09MSUNJVFVERVMiLCJWRVJfVklERU9TX0FVRElFTkNJQVMiLCJNT0RJRklDQVJfUEFSQU1FVFJPUyIsIk1PRElGSUNBUl9VU1VBUklPUyIsIkxJU1RBUl9KVUVDRVMiLCJFTElNSU5BUl9KVUVDRVMiLCJBR0VOREFSX0FVRElFTkNJQVMiLCJDQU5DRUxBUl9BVURJRU5DSUFTIiwiQ1JFQVJfUkVTVUxUQURPUyIsIkNSRUFSX1RVUk5PUyIsIk1PRElGSUNBUl9JTkhJQklDSU9ORVMiLCJMSVNUQVJfSU5ISUJJQ0lPTkVTIiwiRUxJTUlOQVJfVVNVQVJJT1MiLCJMSVNUQVJfVVNVQVJJT1MiLCJDUkVBUl9OT1RJRklDQUNJT05FUyIsIkNSRUFSX09GSUpVUyIsIlZFUl9BR0VOREEiLCJDUkVBUl9TT0xJQ0lUVURFUyIsIkVMSU1JTkFSX09GSUpVUyIsIkxJU1RBUl9QQVJBTUVUUk9TIiwiTU9ESUZJQ0FSX09GSUpVUyIsIlZFUl9BQ1RBU19BVURJRU5DSUFTIiwiRUxJTUlOQVJfRlVOQ0lPTkFSSU9TIiwiUkVWT0NBUl9TT0xJQ0lUVURFUyIsIkFDRVBUQVJfU09MSUNJVFVERVMiLCJMSVNUQVJfVFVSTk9TIiwiVkVSX0FDVEFTX0FVRElFTkNJQVNfUFJPUElBUyIsIkNSRUFSX0ZVTkNJT05BUklPUyIsIkNSRUFSX1BBUkFNRVRST1MiLCJWRVJfVklERU9TX0FVRElFTkNJQVNfUFJPUElBUyIsIkNSRUFSX0pVRUNFUyIsIlJFQ0hBWkFSX1NPTElDSVRVREVTIl0sImp0aSI6IjliNDIzYmJkLWNjYmUtNGE3ZS1iZDMwLTA1ZDIyNzRkZmE0YSIsImNsaWVudF9pZCI6ImZyb250ZW5kYXBwIiwic2NvcGUiOlsicmVhZCIsIndyaXRlIl19.r0oYOih943bE0kyj5wZAX9K6emEZTCaRgrtYangXEzM';

//LISTAR LEVELS
export function listLevelsAction() {
    return async (dispatch) => {
        //Inicializo
        dispatch( listLevels() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            // authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`);
            //Obtengo los datos
            const levels = response.data;
            //Llamo al dispatch
            dispatch( listLevelsSuccess(levels.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listLevelsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listLevels = () => ({
    type: LIST_LEVELS,
    payload: true
});

const listLevelsSuccess = levels => ({
    type: LIST_LEVELS_SUCCESS,
    payload: levels
});

const listLevelsError = error => ({
    type: LIST_LEVELS_ERROR,
    payload: error
});

//ADD AUDIENCE CATEGORY
export function addLevelsAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addLevels(false) );
        //Abro el formulario
        showForm();
    }
}

const addLevels = isEdit => ({
    type: ADD_LEVELS,
    payload: isEdit
});

//SAVE AUDIENCE CATEGORY
export function saveLevelsAction(level, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveLevels() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            // authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, level);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveLevelsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveLevelsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveLevels = () => ({
    type: SAVE_LEVELS,
    payload: true
});


const saveLevelsSuccess = level => ({
    type: SAVE_LEVELS_SUCCESS,
    payload: level
});

const saveLevelsError = error => ({
    type: SAVE_LEVELS_ERROR,
    payload: error
});

//EDIT AUDIENCE CATEGORY
export function editLevelsAction(level, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editLevels(level) );
        //Abro el formulario
        showForm();
    }
}

const editLevels = level => ({
    type: EDIT_LEVELS,
    payload: level
});

//UPDATE AUDIENCE CATEGORY
export function updateLevelsAction(level, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateLevels() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            // authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${level.id}`, level);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateLevelsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateLevelsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateLevels = () => ({
    type: UPDATE_LEVELS,
    payload: true
});

const updateLevelsSuccess = level => ({
    type: UPDATE_LEVELS_SUCCESS,
    payload: level
});

const updateLevelsError = error => ({
    type: UPDATE_LEVELS_ERROR,
    payload: error
});

//DELETE AUDIENCE CATEGORY
export function deleteLevelsAction(level) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteLevels() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            // authToken(token);
            //Hago la consulta
            const response = await clienteAxios.delete(`/${controller}/${level.id}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteLevelsSuccess(level.id) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteLevelsError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteLevels = () => ({
    type: DELETE_LEVELS,
    payload: true
});

const deleteLevelsSuccess = level => ({
    type: DELETE_LEVELS_SUCCESS,
    payload: level
});

const deleteLevelsError = error => ({
    type: DELETE_LEVELS_ERROR,
    payload: error
});